// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QCv6N{position:relative;width:100%;height:100%}.Z8qS5{align-items:flex-start}.Z8qS5 > div:first-child{margin-top:2px}.n4LS_{border-radius:8px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `QCv6N`,
	"statementCheckbox": `Z8qS5`,
	"termsOfServiceContent": `n4LS_`
};
export default ___CSS_LOADER_EXPORT___;
